import { useState } from 'react';
import { useAuditGlobal } from '../hooks/api';
import { Loading, ErrorBox, EmptyBox } from '../components/Loading';
import { formatTimestamp } from '../api';

export default function AuditGlobalPage() {
  const [actionFilter, setActionFilter] = useState('');
  const [actorFilter, setActorFilter] = useState('');
  const [tenantFilter, setTenantFilter] = useState('');
  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');
  const [page, setPage] = useState(0);
  const limit = 100;

  const audit = useAuditGlobal({
    ...(actionFilter ? { action: actionFilter } : {}),
    ...(actorFilter ? { actor: actorFilter } : {}),
    ...(tenantFilter ? { tenant_code: tenantFilter } : {}),
    ...(from ? { from } : {}),
    ...(to ? { to } : {}),
    limit,
    offset: page * limit,
  });

  return (
    <div className="space-y-3">
      <h1 className="text-[14px] font-semibold uppercase tracking-wide text-neutral-700 border-b border-neutral-300 pb-1">
        Audit (Cross-Tenant — platform_db.audit.audit_log_global)
      </h1>

      <div className="panel">
        <div className="panel-h">Filter</div>
        <div className="panel-b grid grid-cols-5 gap-3">
          <div>
            <label className="block text-[11px] text-neutral-600 mb-0.5">Action</label>
            <input
              type="text"
              className="input w-full"
              placeholder="z.B. tenant_registered"
              value={actionFilter}
              onChange={(e) => {
                setActionFilter(e.target.value);
                setPage(0);
              }}
            />
          </div>
          <div>
            <label className="block text-[11px] text-neutral-600 mb-0.5">Actor</label>
            <input
              type="text"
              className="input w-full"
              placeholder="email/host"
              value={actorFilter}
              onChange={(e) => {
                setActorFilter(e.target.value);
                setPage(0);
              }}
            />
          </div>
          <div>
            <label className="block text-[11px] text-neutral-600 mb-0.5">Tenant-Code</label>
            <input
              type="text"
              className="input w-full"
              placeholder="exakt"
              value={tenantFilter}
              onChange={(e) => {
                setTenantFilter(e.target.value);
                setPage(0);
              }}
            />
          </div>
          <div>
            <label className="block text-[11px] text-neutral-600 mb-0.5">Von</label>
            <input
              type="datetime-local"
              className="input w-full"
              value={from}
              onChange={(e) => {
                setFrom(e.target.value);
                setPage(0);
              }}
            />
          </div>
          <div>
            <label className="block text-[11px] text-neutral-600 mb-0.5">Bis</label>
            <input
              type="datetime-local"
              className="input w-full"
              value={to}
              onChange={(e) => {
                setTo(e.target.value);
                setPage(0);
              }}
            />
          </div>
        </div>
      </div>

      <div className="panel">
        <div className="panel-h flex items-center justify-between">
          <span>Eintraege</span>
          <span className="text-[10px] text-neutral-500 font-mono">
            {audit.data
              ? `${page * limit + 1}–${page * limit + audit.data.data.length} / ${audit.data.total}`
              : '–'}
          </span>
        </div>
        <div className="panel-b p-0">
          {audit.isLoading && (
            <div className="p-2">
              <Loading />
            </div>
          )}
          {audit.error && (
            <div className="p-2">
              <ErrorBox error={audit.error} />
            </div>
          )}
          {audit.data && audit.data.data.length === 0 && (
            <div className="p-2">
              <EmptyBox>Keine Treffer.</EmptyBox>
            </div>
          )}
          {audit.data && audit.data.data.length > 0 && (
            <table className="tbl">
              <thead>
                <tr>
                  <th>Zeitpunkt</th>
                  <th>Actor</th>
                  <th>Tenant</th>
                  <th>Action</th>
                  <th>Target</th>
                  <th>Trace</th>
                </tr>
              </thead>
              <tbody>
                {audit.data.data.map((r) => (
                  <tr key={r.id}>
                    <td className="mono">{formatTimestamp(r.occurred_at)}</td>
                    <td className="mono text-[11px]">
                      {r.actor_type}/{r.actor_ref ?? ''}
                    </td>
                    <td className="mono">{r.tenant_code ?? ''}</td>
                    <td className="mono">{r.action}</td>
                    <td className="mono text-[11px]">
                      {r.target_kind ? `${r.target_kind}:${r.target_ref ?? ''}` : ''}
                    </td>
                    <td className="mono text-[10px] text-neutral-500">{r.trace_id ?? ''}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
        {audit.data && audit.data.total > limit && (
          <div className="border-t border-neutral-300 px-3 py-1.5 flex items-center justify-end gap-2">
            <button
              type="button"
              className="btn"
              disabled={page === 0}
              onClick={() => setPage((p) => Math.max(0, p - 1))}
            >
              ← vorher
            </button>
            <span className="text-[11px] text-neutral-600 font-mono">Seite {page + 1}</span>
            <button
              type="button"
              className="btn"
              disabled={(page + 1) * limit >= audit.data.total}
              onClick={() => setPage((p) => p + 1)}
            >
              naechste →
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
